import Platform from '@/assets/icons/Platform'
import { routes } from '@/routes/utils'
import useAuthStore from '@/stores/useAuthStore'
import useNavStore from '@/stores/useNavStore'
import { cn } from '@/utils/shadcn'
import { SlidersHorizontal } from 'lucide-react'
import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate } from 'react-router-dom'

const ToggleMenu = ({ className }: { className?: string }) => {
  const navigate = useNavigate()
  const { pathname } = useLocation()
  const { user } = useAuthStore()
  const isHrManager = !!user?.companyMember?.isHrManager
  const { showManagement, setShowManagement } = useNavStore()
  const { t } = useTranslation()

  // Keep the switch in sync with the section the user is actually in.
  useEffect(() => {
    const isManagementPath =
      [
        routes.companyDashboard.getPath(),
        routes.manageRequests.getPath(),
        routes.manageSeats.getPath(),
      ].includes(pathname) || pathname.startsWith(routes.interventionDashboard.getPath())
    if (isManagementPath) {
      setShowManagement(true)
    }
  }, [pathname, setShowManagement])

  // "Beheer" is the Interventiedesk for HR managers, company management for admins.
  const managementHome = isHrManager
    ? routes.interventionDashboard.getPath()
    : routes.companyDashboard.getPath()

  const handleToggleMenu = (isManaging) => {
    setShowManagement(isManaging)
    if (isManaging) {
      navigate(managementHome)
    } else {
      navigate('/')
    }
  }

  return (
    <div
      className={cn(
        'mr-6 flex h-10 w-fit rounded-full bg-[#F1EFEB] p-1 text-xs font-medium xl:text-sm',
        className,
      )}
    >
      <div
        className={cn('flex cursor-pointer items-center gap-2.5 rounded-full px-4 opacity-50', {
          'bg-[#BFE1F1] opacity-100': showManagement,
        })}
        onClick={() => handleToggleMenu(true)}
      >
        <SlidersHorizontal size={16} />
        {t('menu.manage')}
      </div>
      <div
        className={cn('flex cursor-pointer items-center gap-2.5 rounded-full px-4 opacity-50', {
          'bg-[#F9E4B4] opacity-100': !showManagement,
        })}
        onClick={() => handleToggleMenu(false)}
      >
        <Platform />
        Platform
      </div>
    </div>
  )
}

export default ToggleMenu
